import { type ContextMenuList } from '../types/context-menu-list.type';
import { ContextMenuListItemType } from '../types/context-menu-list-item-type.enum';

export const removeBreakpointMenuItem = (): ContextMenuList => {
	return {
		type: ContextMenuListItemType.Item,
		content: 'Remove Breakpoint',
		isVisible: ({ controller }): boolean => {
			return !controller.readonly;
		},
		onClick: ({ refMap }): void => {
			const { breakpoint, panel, countertop } = refMap;

			// Check which breakpoints collection actually contains this breakpoint
			// Panel/Backsplash breakpoints take priority over countertop breakpoints
			// (backsplash refMap has panel reference due to inheritance)
			if (panel?.breakpoints?.children?.some((bp) => bp.id === breakpoint.id)) {
				panel.breakpoints.delete(breakpoint.id);
			} else if (countertop?.breakpoints?.children?.some((bp) => bp.id === breakpoint.id)) {
				countertop.breakpoints.delete(breakpoint.id);
			}
		}
	}
};
